// TODO: change captcha site key
export const CAPTCHA_SITE_KEY = "6LdvpzYnAAAAAB1ByyFlmi1Wxi6pJT4CJxx2Y41t";